import axios from "axios";

const rawBaseUrl = (process.env.REACT_APP_API_URL || "").trim();

/** В браузере — всегда тот же хост, что у страницы (домен или LAN IP). */
const resolveBaseUrl = () => {
    if (typeof window !== "undefined" && window.location && window.location.origin) {
        return window.location.origin;
    }
    return rawBaseUrl || "http://127.0.0.1:3000";
};

const defaultBaseUrl = resolveBaseUrl();
const http = axios.create({
    baseURL: defaultBaseUrl
});

const buildFallbackCandidates = (baseUrl) => {
    const candidates = [];
    try {
        const parsed = new URL(baseUrl);
        const hasCustomPort = Boolean(parsed.port);
        if (!hasCustomPort) {
            candidates.push(`${parsed.protocol}//${parsed.hostname}:3000`);
        }
        candidates.push(window.location.origin);
    } catch (err) {
        candidates.push(window.location.origin);
    }
    return [...new Set(candidates)].filter((item) => item && item !== baseUrl);
};

const readHeader = (headers, name) => {
    if (!headers) {
        return null;
    }
    if (typeof headers.get === "function") {
        return headers.get(name) || headers.get(name.toLowerCase()) || null;
    }
    return headers[name] || headers[name.toLowerCase()] || null;
};

const notifyAuthExpired = (config) => {
    if (!config || config.__auth401Handled) {
        return;
    }
    const url = String(config.url || "");
    if (!url.includes("api")) {
        return;
    }
    config.__auth401Handled = true;
    const adminTok = readHeader(config.headers, "x-admin-token");
    const cropTok = readHeader(config.headers, "x-crop-token");
    const statTok = readHeader(config.headers, "x-stat-token");
    if (adminTok) {
        try {
            localStorage.removeItem("adminToken");
        } catch (e) {
            /* ignore */
        }
        window.dispatchEvent(new CustomEvent("printorder:admin-session-expired"));
    }
    if (cropTok) {
        try {
            sessionStorage.removeItem("cropToken");
        } catch (e) {
            /* ignore */
        }
        try {
            localStorage.removeItem("cropToken");
        } catch (e) {
            /* ignore */
        }
        window.dispatchEvent(new CustomEvent("printorder:crop-session-expired"));
    }
    if (statTok) {
        try {
            localStorage.removeItem("statToken");
        } catch (e) {
            /* ignore */
        }
        window.dispatchEvent(new CustomEvent("printorder:stat-session-expired"));
    }
};

http.interceptors.response.use(
    (response) => response,
    async (error) => {
        const config = error && error.config ? error.config : null;
        const status = error.response ? error.response.status : null;
        if (status === 401) {
            notifyAuthExpired(config);
        }
        if (!config || config.__fallbackTried) {
            return Promise.reject(error);
        }

        // Retry once against a fallback base URL for misconfigured API host.
        const shouldRetry = !status || status === 404 || status >= 500;
        if (!shouldRetry) {
            return Promise.reject(error);
        }

        const currentBase = config.baseURL || defaultBaseUrl;
        const candidates = buildFallbackCandidates(currentBase);
        if (candidates.length === 0) {
            return Promise.reject(error);
        }

        config.__fallbackTried = true;
        config.baseURL = candidates[0];
        return http.request(config);
    }
);

export default http;